import { useMutation } from "@apollo/client";
import { UPDATE_BUYING_LIMITATIONS } from "../pharmacyTypeDefs";

export const useMutationUpdateBuyingLimitations = (options?: any): any => (
  useMutation(UPDATE_BUYING_LIMITATIONS, options)
);
